export class ApiLocalStorage {
  private static readonly TIMEOUT = 5000;
  
  static set(key: string, data: any) {
    try {
      localStorage.setItem(key, JSON.stringify(data));
      
      return true;
    } catch {
      return false;
    }
  }
  
  static get(key: string) {
    try {
      const data = localStorage.getItem(key);
      
      if (!data) return null;
      
      return JSON.parse(data);
    } catch {
      return null;
    }
  }
  
  static remove(key: string) {
    try {
      localStorage.removeItem(key);
      
      return true;
    } catch {
      return false;
    }
  }
}

// export class ApiLocalStorage {
//   private static readonly SECRET_KEY = 'SECRET_KEY';
//   private static readonly TIMEOUT = 5000;
//
//   static set(key: string, data: any) {
//     try {
//       const encrypted = CryptoJS.AES.encrypt(
//         JSON.stringify(data),
//         this.SECRET_KEY
//       ).toString();
//       localStorage.setItem(key, encrypted);
//
//       return true;
//     } catch {
//       return false;
//     }
//   }
//
//   static get(key: string) {
//     try {
//       const encrypted = localStorage.getItem(key);
//
//       if (!encrypted) return null;
//
//       const decrypted = CryptoJS.AES.decrypt(encrypted, this.SECRET_KEY);
//       const data = decrypted.toString(CryptoJS.enc.Utf8);
//
//       return data ? JSON.parse(data) : null;
//     } catch {
//       return null;
//     }
//   }
//
//   static remove(key: string) {
//     try {
//       localStorage.removeItem(key);
//
//       return true;
//     } catch {
//       return false;
//     }
//   }
// }
